import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhoWeWorkWithSection from './components/WhoWeWorkWithSection';
import WhyDecimalSection from './components/WhyDecimalSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <WhoWeWorkWithSection />
      <WhyDecimalSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
